import { render, staticRenderFns } from "./LanguageCertificateCopy.vue?vue&type=template&id=19dd4ce8&"
import script from "./LanguageCertificateCopy.vue?vue&type=script&lang=js&"
export * from "./LanguageCertificateCopy.vue?vue&type=script&lang=js&"
import style0 from "./LanguageCertificateCopy.vue?vue&type=style&index=0&id=19dd4ce8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports